import { memo, useCallback, useMemo } from "react";
import {
  BottomSheetBackdrop,
  BottomSheetBackdropProps,
  BottomSheetModal,
  BottomSheetModalProps,
} from "@gorhom/bottom-sheet";
import { StyleSheet } from "react-native";
import { useUnistyles } from "react-native-unistyles";
import { AppMotion } from "@src/constants/motion";

type AppBottomSheetProps = {
  bottomSheetRef: React.RefObject<BottomSheetModal | null>;
  children: BottomSheetModalProps["children"];
} & Omit<BottomSheetModalProps, "ref" | "backdropComponent" | "children">;

export const AppBottomSheet = memo(({ bottomSheetRef, children, ...rest }: AppBottomSheetProps) => {
  const { theme } = useUnistyles();
  const { handleIndicatorStyle, ...modalProps } = rest;
  const mergedHandleIndicatorStyle = useMemo(
    () => ({
      backgroundColor: theme.colors.field.border_default,
      width: 46,
      ...StyleSheet.flatten(handleIndicatorStyle),
    }),
    [handleIndicatorStyle, theme.colors.field.border_default],
  );

  const renderBackdrop = useCallback(
    (props: BottomSheetBackdropProps) => <BottomSheetBackdrop {...props} disappearsOnIndex={-1} appearsOnIndex={0} />,
    [],
  );

  const animationConfigs = useMemo(() => ({ ...AppMotion.spring.subtle }), []);

  return (
    <BottomSheetModal
      ref={bottomSheetRef}
      enablePanDownToClose
      animationConfigs={animationConfigs}
      backdropComponent={renderBackdrop}
      handleIndicatorStyle={mergedHandleIndicatorStyle}
      handleStyle={{ paddingTop: theme.spacing["6xl"] }}
      {...modalProps}
    >
      {children}
    </BottomSheetModal>
  );
});
